import labels from './labels'
import fields from './fields'
import projects from './projects'
import lists from './lists'
import comment from './comment'
import users from './users'

const initialState = () => ({
  account_provider_id: null,
  name: null,
  slug: null,
  custom_services: []
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    addCustomService({ commit, dispatch }, serviceName) {
      // register with top level provider
      commit('addCustomService', serviceName)

      // set name of service
      dispatch(`provider/${serviceName}/name`, serviceName, { root: true })
    },
    async findCoreServices({ state, dispatch }) {
      await dispatch(`provider/lists/find`, null, { root: true })
      // await dispatch(`provider/users/find`, null, { root: true })
    },
    async fetchCustomServices({ state, dispatch }) {
      // iterate and fetch all services
      for (let serviceName of state.custom_services) {
        await dispatch(`provider/${serviceName}/find`, null, { root: true })
      }
    }
  },
  mutations: {
    assign(state, { account_provider_id, name, slug }) {
      state.account_provider_id = account_provider_id
      state.name = name
      state.slug = slug
    },
    addCustomService(state, serviceName) {
      state.custom_services.push(serviceName)
    }
  },
  modules: {
    labels,
    fields,
    projects,
    lists,
    comment,
    users
  }
}
